import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const AccountVerificationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const addToWhitelist = (customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/account-verification/whitelist/add/customer/${customerId}`,
      {},
      {
        headers,
      }
    );
  };

  const getActiveWhitelist = (customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(
      `${BASE_URL}/account-verification/whitelist/customer/${customerId}`,
      {
        headers,
      }
    );
  };

  service.addToWhitelist = addToWhitelist;
  service.getActiveWhitelist = getActiveWhitelist;

  return service;
})();

export default AccountVerificationService;
